<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc-bot"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Chapter I</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Chapter II</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">Chapter III</a></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Chapter IV</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter V</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Chapter VI</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Chapter VII</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Chapter VIII</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Chapter IX</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter X</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter XI</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter XII</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter XIII</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter XIV</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter XV</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Chapter XVI</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Chapter XVII</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Chapter XVIII</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Chapter XIX</span></p>
<p class="toc"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Chapter XX</span></p>
<p class="toc"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Chapter XXI</span></p>
<p class="toc"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Chapter XXII</span></p>
<p class="toc"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Chapter XXIII</span></p>
<p class="toc"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Chapter XXIV</span></p>
<p class="toc"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Chapter XXV</span></p>
<p class="toc"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Chapter XXVI</span></p>
<p class="toc"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">Chapter XXVII</span></p>
<p class="toc"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">Chapter XXVIII</span></p>
<p class="toc"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">Chapter XXIX</span></p>
<p class="toc"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample">Chapter XXX</span></p>
<p class="toc"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample">Chapter XXXI</span></p>
<p class="toc"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample">Chapter XXXII</span></p>
<p class="toc"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample">Chapter XXXIII</span></p>
<p class="toc"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample">Chapter XXXIV</span></p>
<p class="toc"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample">Chapter XXXV</span></p>
<p class="toc"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample">Chapter XXXVI</span></p>
<p class="toc"><span href="#/xhtml/chapter37#ch37" title="Link target outside of Sample">Chapter XXXVII</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter38#ch38" title="Link target outside of Sample">Chapter XXXVIII</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Books by Carlos Fuentes</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0576faec